import Vue from 'vue'
import Vuex from 'vuex'
import './plugins/vuetify'

import axios from 'axios'
import VueAxios from 'vue-axios'

import router from './router'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

import App from './App.vue'

// Vue.use(Vuetify, {
//   components: {
//     VApp,
//     //VNavigationDrawer,
//     VFooter,
//     //VList,
//     VBtn,
//     VIcon,
//     VGrid,
//     VCard,
//     VToolbar,
//     VProgressLinear,
//     VDivider,
//     VTextField,
//     VSubheader,
//     VCarousel,
//     VPagination,
//     transitions
//   },
//   theme: {
//     primary: '#ee44aa',
//     secondary: '#424242',
//     accent: '#82B1FF',
//     error: '#FF5252',
//     info: '#2196F3',
//     success: '#4CAF50',
//     warning: '#FFC107'
//   }
// });

Vue.use(Vuex);
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

import VueXStore from './store'

const store = VueXStore.getStore();

/**
 * 格式化文件大小
 */
Vue.filter('fileSize', function (size) {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB'
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB'
  }
  return size.toString() + ' B'
});

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   store,
//   router,
//   components: {App},
//   template: '<App/>'
// });

// 自定义的工具函数
import utils from './utils'

window.xutil = utils;


new Vue({
  store,
  router,
  render: h => h(App),
  // lang: {
  //     locales: {zhHans},
  //     current: 'zhHans',
  // },
}).$mount('#app')
